<template>
	<div class="app-main">
		<el-row :gutter="20">
			<el-col :span="6" :xs="24">
				<el-card shadow="always">
					<div slot="header" class="clearfix">
						<span>个人信息</span>
					</div>
					<div>
						<div class="text-center">
							<userAvatar />
						</div>
						<ul class="list-group list-group-striped">
							<li class="list-group-item">
								<i class="el-input-icon el-icon-user"></i>用户名称
								<div class="pull-right">{{user.nickname}}</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon el-icon-star-on"></i>用户账号
								<div class="pull-right">{{user.username}}</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon el-icon-mobile-phone"></i>手机号码
								<div class="pull-right">{{user.phone}}</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon el-icon-message"></i>用户邮箱
								<div class="pull-right">{{user.email}}</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon ali-iconfont icon-bumen"></i>所属部门
								<div class="pull-right">{{user.deptName}}</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon el-icon-user-solid"></i>所属角色
								<div class="pull-right">
									<!-- <span v-for="item in user.roles" :key="item.id">{{item.code}} </span> -->
									<span>{{roleName}} </span>
								</div>
							</li>
							<li class="list-group-item">
								<i class="el-input-icon el-icon-date"></i>创建日期
								<div class="pull-right">{{user.createTime}}</div>
							</li>
						</ul>
					</div>
				</el-card>
			</el-col>
			<el-col :span="18" :xs="24">
				<el-card>
					<div slot="header" class="clearfix">
						<span>基本资料</span>
					</div>
					<el-tabs v-model="activeTab">
						<el-tab-pane label="基本资料" name="userinfo">
							<userInfo :user="user" />
						</el-tab-pane>
						<el-tab-pane label="修改密码" name="resetPwd">
							<resetPwd :user="user" />
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import userAvatar from "./userAvatar";
	import userInfo from "./userInfo";
	import resetPwd from "./resetPwd";
	export default {
		components: {
			userAvatar,
			userInfo,
			resetPwd
		},
		computed: {
			user() {
				return this.$store.getters['user/user'];
			},
			roleName(){
				let names = [];
				if(this.user){
					let roles = this.user.roles || [];
					roles.forEach((item)=>{
						names.push(item.roleName)
					})
				}
				return names.join(',')
			},
		},
		data() {
			return {
				roleGroup: {},
				postGroup: {},
				activeTab: "userinfo"
			};
		},
		created() {},
		methods: {

		}
	};
</script>
<style scoped="scoped" lang="scss">
	.text-center {
		text-align: center;
	}

	.list-group {
		padding-left: 0;
		list-style: none;
		margin: 16px auto;
	}

	.list-group-striped>.list-group-item {
		border-left: 0;
		border-right: 0;
		border-radius: 0;
		padding-left: 0;
		padding-right: 0;
	}

	.list-group-item {
		border-bottom: 1px solid #e7eaec;
		border-top: 1px solid #e7eaec;
		margin-bottom: -1px;
		padding: 11px 0;
		font-size: 13px;
	}

	.pull-right {
		float: right
	}

	.el-input-icon {
		height: 100%;
		width: 25px;
		text-align: center;
		transition: all .3s;
	}

	.icon-bumen {
		font-size: 13px;
	}
</style>
